/**
 * Light haptic feedback when supported (mobile).
 */
export function hapticLight() {
  if (typeof navigator === 'undefined') return;
  if (navigator.vibrate) {
    navigator.vibrate(10);
  }
}
